const Blogs = () => {
    return ( 
    <div>
         <section class="container" id="blogs">
            <div class="blogs-content">
                <div class="main-title">
                    <h2>My <span>Blogs</span><span class="bg-text">My Blogs</span></h2>
                </div>
                <div class="blogs">
                    <div class="blog">
                        <img src="img/port.jpg" alt=""/>
                        <div class="blog-text">
                            <h4>
                                How to Create Your Own Website
                            </h4>
                            <p>
                            Choose a domain, select a website builder or CMS, create content, and publish your website
                            </p>
                        </div>
                    </div>
                    <div class="blog">
                        <img src="img/port2.jpg" alt=""/>
                        <div class="blog-text">
                            <h4>
                                Become an Expert in networking
                            </h4>
                            <p>
                            Learn networking concepts, protocols, and tools, practice with labs, and keep up with industry developments.
                            </p>
                        </div>
                    </div>
                    <div class="blog">
                        <img src="img/port3.jpg" alt=""/>
                        <div class="blog-text">
                            <h4>
                                Become a Mobile application developer  in 10 Days
                            </h4>
                            <p>
                            It's not possible to become a proficient mobile developer in 10 days, it requires dedication and practice over a longer period.
                            </p>
                        </div>
                    </div>
                    <div class="blog">
                        <img src="img/port4.jpg" alt=""/>
                        <div class="blog-text">
                            <h4>
                                Cloud computing
                            </h4>
                            <p>
                            Internet connection, knowledge of networking, virtualization, and cloud computing services and deployment models
                            </p>
                        </div>
                    </div>
                    <div class="blog">
                        <img src="img/port5.jpg" alt=""/>
                        <div class="blog-text">
                            <h4>
                                All you need to know about data science
                            </h4>
                            <p>
                            Data science involves extracting insights and knowledge from data through statistical and machine learning techniques.
                            </p>
                        </div>
                    </div>
                    <div class="blog">
                        <img src="img/port6.jpg" alt=""/>
                        <div class="blog-text">
                            <h4>
                                Getting started with embedded systems
                            </h4>
                            <p>
                            Learn C/C++, microcontroller architecture, and interfacing, choose a development board, and experiment with projects.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div> 
    );
}
 
export default Blogs;